export default {
  ADD_NEW_EVENT_PLACE (state, place) {
    state.eventCities.push(place)
  },
  ADD_EVENT_PLACES (state, eventCities) {
    state.eventCities = eventCities
  },
  ADD_EVENT_PLACE (state, eventCity) {
    state.eventCity = eventCity
  },
  ADD_NEW_EVENT (state, event) {
    state.event = event
    state.events.push(event)
  },
  ADD_EVENT (state, event) {
    state.event = event
  },
  ADD_EVENTS (state, events) {
    state.events = events
  },
  DELETE_EVENT_PLACE (state, cityId) {
    state.eventCities = state.eventCities.filter(s => s.id !== cityId)
    if (state.eventCities[0]) {
      state.eventCity = state.eventCities[0]
    }
  },
  ADD_EVENT_ITEM (state, item) {
    item.speakers = []
    state.event.eventItems.push(item)
  },
  UPDATE_EVENTS_PLACES (state, cities) {
    state.eventCities = cities
  },
  CHANGE_EVENT_PHOTO (state, event) {
    state.event.photo = event.photo
    state.event.base64photo = null
  },
  UPDATE_EVENT (state, event) {
    Object.assign(state.event, event)
  },
  ADD_NEW_SPEAKER (state, speaker) {
    const eventItem = state.event.eventItems.find(e => e.id === speaker['event_item_id'])
    eventItem.speakers = eventItem.speakers ? [ ...eventItem.speakers, speaker ] : [speaker]
  },
  CHANGE_SUMMARY_PHOTO (state, photos) {
    state.event.photos = photos
  },
  DELETE_SUMMARY_PHOTO (state, photo) {
    if (typeof photo === 'string') {
      state.event.photos = state.event.photos.filter(p => p !== photo)
    } else {
      state.event.photos = state.event.photos.filter(p => p.base64photo !== photo.base64photo)
    }
  },
  DELETE_SPEAKER (state, id) {
    let eventItem = state.event.eventItems.find(e => e.speakers.find(s => s.id === id))
    eventItem.speakers = eventItem.speakers.filter((s) => {
      return s.id !== id
    })
  },
  DELETE_EVENT_ITEM (state, id) {
    state.event.eventItems = state.event.eventItems.filter((s) => {
      return s.id !== id
    })
  },
  UPDATE_EVENT_ITEM (state, item) {
    Object.assign(state.event.eventItems.find(i => i.id === item.id), item)
  },
  UPDATE_EVENT_SPEAKER (state, speaker) {
    const eventItem = state.event.eventItems.find(i => i.id === speaker.event_item_id)
    const oldSpeaker = eventItem.speakers.find(s => s.id === speaker.id)
    Object.assign(oldSpeaker, speaker)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/events.js